export default "__VITE_PUBLIC_ASSET__704abbe4__"